<template>
  <router-view/>
  <LoaderView />
</template>

<script setup>
import LoaderView from './core/components/LoaderView.vue';

</script>

<style>

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  -webkit-touch-callout: none;
  scroll-behavior: auto !important;
}
/* width */
::-webkit-scrollbar {
  width: 2px;
}

.grecaptcha-badge {
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

.scroller {
  overflow-y: scroll;
  scrollbar-color: #0A4C95 #C2D2E4;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #202124;
  margin-top: 0px;
  padding: 0px;
  list-style: none;
  border: none;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
  display: grid;
}

article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

.container-fluid {
  height: calc(100vh - 205px);
  display: grid;
  justify-content: center;
  align-items: center;
  width: 100%;
}

/*  Style to delete visual text copy ...*/

* {
  user-select: none;
}

*::selection {
  background: none;
}

*::-moz-selection {
  background: none;
}

/* Global styles*/
.container-super {
  height: 100%;
  width: 100%;
  display: grid;
  background-color: white;
}

.container-logo-baz {
  z-index: 1;
  position: absolute;
  top: 30px;
  left: 60px;
  max-width: 120px;
  max-height: 120px;
}
.container-logo-baz img {
  width: 65px;
  height: 60px;
  max-width: 70px;
  max-height: 65px;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
   font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (max-width: 320px) and (orientation: portrait) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px)
  and (orientation: landscape) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px)
  and (orientation: portrait) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    margin-top: 20px;
    font-size: 30px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px)
  and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 30px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px)
  and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 30px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-width: 1224px) {
  h1 {
    font-size: 50px;
  }
  .title-header {
    font-size: 30px;
  }
  h2 {
    font-size: 20px;
  }
  p {
    font-size: 20px;
  }
  a {
    font-size: 18px;
  }
  span {
    font-size: 20px;
  }
  button span {
    font-size: 16px;
  }
}
@media only screen and (min-width: 1824px) {
  h1 {
    font-size: 50px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  a {
    font-size: 18px;
  }
  span {
    font-size: 20px;
  }
  button span {
    font-size: 16px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px)
  and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 16px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 10px;
  }
  a {
    font-size: 10px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 8px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px)
  and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-height: 568px)
  and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 16px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 10px;
  }
  a {
    font-size: 10px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 8px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-height: 568px)
  and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 667px)
  and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 16px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 10px;
  }
  a {
    font-size: 10px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 8px;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 667px)
  and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 16px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 10px;
  }
  a {
    font-size: 10px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 8px;
  }
}
@media only screen and (min-device-width: 414px) and (max-device-height: 736px)
  and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 16px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 10px;
  }
  a {
    font-size: 10px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 8px;
  }
}
@media only screen and (min-device-width: 414px) and (max-device-height: 736px)
  and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 812px)
  and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 16px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 10px;
  }
  a {
    font-size: 10px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 8px;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 812px)
  and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 414px) and (max-device-height: 896px)
  and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 16px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 10px;
  }
  a {
    font-size: 10px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 8px;
  }
}
@media only screen and (min-device-width: 414px) and (max-device-height: 896px)
  and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-height: 640px)
  and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 16px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 10px;
  }
  a {
    font-size: 10px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 8px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-height: 640px)
  and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-height: 640px)
  and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 16px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 10px;
  }
  a {
    font-size: 10px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 8px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-height: 640px)
  and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 360px) and (max-device-height: 640px)
  and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  h1 {
    font-size: 16px;
  }
  h2 {
    font-size: 16px;
  }
  .title-header {
    font-size: 20px;
  }
  p {
    font-size: 10px;
  }
  a {
    font-size: 10px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 8px;
  }
}
@media only screen and (min-device-width: 360px) and (max-device-height: 640px)
and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 20px;
  }
  .title-header {
    font-size: 20px;
    margin-bottom: 20px;
  }
  p {
    font-size: 14px;
  }
  a {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  button span {
    font-size: 12px;
  }
}
/* Color colors ... */
:root {
  --danger : red;
  --white  : #ffffff;
}

</style>
